module.exports = __webpack_public_path__ + "assets/img/Type DK.d887e2f5.jpg";